export default __webpack_public_path__ + "static/media/meditation.7ee1d583.mp3";